import React from "react";
import "../styles/theme.css"; // Archivo CSS para los estilos

const Banner = () => {
  return (
    <div className="banner-container">
      <img
        src="https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=444,fit=crop,q=95/YD06ZbNDaEiW9ZZw/logo-ALpnjKNBrNTQz54X.png" // Reemplaza con la URL de tu imagen
        alt="Banner"
        className="banner-image"
      />
    </div>
  );
};

export default Banner;
